import React, { useEffect } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { nav } from "./RoutesSetup";
import { useContext } from "react";
import AuthContext from "../store/AuthContext";
import VerifyCode from '../pages/Verifycode/VerifyCode'; // Import VerifyCode component

const RenderRoutes = () => {
  const authCtx = useContext(AuthContext);
  const isAuth = authCtx.auth;

  const user = { isAuthenticated: isAuth };
        console.log("user.isAuthenticated: " + user.isAuthenticated)

  return (
    <Routes>
      {
        nav.map((r, i) => {
          if (r.isPrivate && user.isAuthenticated === 2) {
            return <Route key={i} path={r.path} element={r.element} />;
          } else if (user.isAuthenticated === 1) {
            return <Route key={i} path={r.path} element={< VerifyCode />} />;
          } else if (!r.isPrivate) {
            return <Route key={i} path={r.path} element={r.element} />;
          } else {
            return <Route key={i} path={r.path} element={<Navigate to="/login" />} />;
          }
        })
      }
    </Routes>
  );
};

export default RenderRoutes;
